import React from 'react';
import { View, Image, StyleSheet } from 'react-native';
import { Color, CommonProperties } from '../../../styles';
import { scale } from '../../../utils/scale.utils';
import BaseText from '../../BaseText';
import Icon from '../../Icon';

export const AvatarActionTypes = {
  CANCEL: 'cancel',
  ACTIVE: 'active',
};

const avatarSize = scale(48);
const AvatarTraveler = ({ type = 'cancel', label }) => {
  return (
    <View style={{ width: avatarSize, ...CommonProperties.ml5 }}>
      {type === AvatarActionTypes.CANCEL || type === AvatarActionTypes.ACTIVE ? (
        <View
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: scale(17),
            height: scale(17),
            borderRadius: scale(8.5),
            backgroundColor: 'white',
            zIndex: 9,
            padding: 0,
            ...CommonProperties.centerAlignment,
          }}
        >
          {type === AvatarActionTypes.CANCEL ? (
            <Icon style={styles.icon} name="circleCancel" color={Color.primary} />
          ) : null}
          {type === AvatarActionTypes.ACTIVE ? (
            <Icon style={styles.icon} name="circleCheck" color="#82c42c" />
          ) : null}
        </View>
      ) : null}
      <Image
        source={{ uri: 'https://picsum.photos/100' }}
        style={{ width: avatarSize, height: avatarSize, borderRadius: avatarSize / 2 }}
      />
      <BaseText ellipsizeMode="tail" numberOfLines={1}>
        {label}
      </BaseText>
    </View>
  );
};

const styles = StyleSheet.create({
  icon: {
    fontSize: scale(18),
  },
});
export default AvatarTraveler;
